import { ActualsValueTypes, DEFAULT_NETNDP } from 'partner360/models/actualValueTypes'

export const getKeyInitiativeTargetValueType = (
  valueType?: string | null,
  defaultValueType: string = DEFAULT_NETNDP
): Exclude<ActualsValueTypes, ActualsValueTypes.None> => {
  const types = Object.values(ActualsValueTypes).filter(
    (type): type is Exclude<ActualsValueTypes, ActualsValueTypes.None> =>
      type !== ActualsValueTypes.None
  )
  const findType = (value?: string | null) =>
    types.find((type) => type.toLowerCase() === value?.trim().toLowerCase())

  return findType(valueType) ?? findType(defaultValueType) ?? DEFAULT_NETNDP
}

export const isValidKeyInitiativeFinancialTarget = (value: number | null | undefined): boolean =>
  typeof value === 'number' && Number.isFinite(value) && value > 0
